var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"helpIndex"}},[_c('topheader'),_c('topsearch'),(_vm.fixedkey)?_c('flxedsearch',{class:{v_fixed:_vm.fixedkey}}):_vm._e(),_c('personal'),_c('router-view'),_c('footerhtml'),_c('copyright'),_c('rightflxed')],1)}
var staticRenderFns = []

export { render, staticRenderFns }